module.exports = __webpack_public_path__ + "img/avatar-1577909_960_720-min.5cfa0778.png";